import React,{useEffect,useState} from 'react';
import {Card,Container,Row,Col,Spinner,Button} from 'react-bootstrap';
import {fetch} from '../../../../utils';
import {Link,useParams} from 'react-router-dom';
import {BASE_URL} from '../../../../config';
import CryptoJS from 'crypto-js';

const OrderDetails=()=>{
    const {orderId}=useParams();
    const [orderData,setOrderData]=useState(null);
    const [isLoading,setIsLoading]=useState(true);

    const getOrderDetails=async()=>{
        try{
            const response=await fetch('/order/details','POST',{cust_order_id:orderId},null);
            setOrderData(response?.data?.data?.order||null);
        }catch(error){
            console.error('ORDER DETAILS ERROR:',error);
        }finally{
            setIsLoading(false);
        }
    };

    useEffect(()=>{getOrderDetails();},[orderId]);

    const formatDate=date=>{
        if(!date)return '-';
        return new Date(date).toLocaleDateString('en-IN',{
            day:'2-digit',
            month:'long',
            year:'numeric'
        });
    };

    const orderStatusList=[
        {order_status:1,order_status_name:'Inserted',className:'text-warning'},
        {order_status:2,order_status_name:'Confirm',className:'text-success'},
        {order_status:3,order_status_name:'Cancelled',className:'text-danger'},
        {order_status:4,order_status_name:'Dispatched',className:'text-danger'},
        {order_status:5,order_status_name:'Delivered',className:'text-success'},
        {order_status:6,order_status_name:'Amount Mismatch',className:'text-warning'}
    ];

    if(isLoading){
        return(
            <Container>
                <div className="text-center mt-5" style={{height:'350px'}}>
                    <Spinner animation="border"/>
                </div>
            </Container>
        );
    }

    if(!orderData){
        return(
            <Container>
                <div className="text-center mt-5">
                    <h4>Order details not available</h4>
                </div>
            </Container>
        );
    }

    const paymentResponse=orderData.payment_response||{};
    const paymentSuccess=String(orderData.payment_status_name||'').toLowerCase()==='success';
    const invoiceUrl=`${BASE_URL}/order/invoice/${orderId}/${CryptoJS.SHA1(orderId)}`;
    const orderStatus=orderStatusList.find(x=>x.order_status===orderData.order_status);

    return(
        <>
            <hr/>
            <Container>
                <div className="py-3">
                    <font>Home › Shopping › Order</font>
                </div>

                <div className="text-center mb-4">
                    <p className="mb-1 text-secondary">THANK YOU</p>
                    <h3>Your order is {orderData.order_status_name}</h3>

                    {paymentSuccess&&(
                        <p className="text-success fw-bold mb-0">
                            Payment Successful
                        </p>
                    )}
                </div>

                <Row className="mt-3">
                    <Col sm={5}>
                        <div className="bg-light p-4">

                            <h5>Order Information</h5>

                            <div className="mb-2">
                                <b>Order No:</b> {orderData.order_no||'-'}
                            </div>

                            <div className="mb-2">
                                <b>Order Date:</b> {formatDate(orderData.order_datetime)}
                            </div>

                            <div className="mb-2">
                                <b>Order Status:</b>{' '}
                                <span className={orderStatus?.className||''}>
                                    {orderData.order_status_name||'-'}
                                </span>
                            </div>

                            {orderData.invoice_no&&(
                                <div className="mb-2">
                                    <b>Invoice No:</b>{' '}
                                    <a
                                        href={invoiceUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {orderData.invoice_no}
                                    </a>
                                </div>
                            )}

                            <hr/>

                            <h5>Payment Information</h5>

                            <div className="mb-2">
                                <b>Payment Status:</b>{' '}
                                <span className={paymentSuccess?'text-success':'text-danger'}>
                                    {orderData.payment_status_name||'-'}
                                </span>
                            </div>

                            <div className="mb-2">
                                <b>Payment Method:</b>{' '}
                                {orderData.payment_method||
                                    paymentResponse.payment_method_display_name||
                                    paymentResponse.payment_method_type||
                                    paymentResponse.method||
                                    '-'}
                            </div>

                            <div className="mb-2">
                                <b>HDFC Order ID:</b>{' '}
                                {orderData.payment_order_id||'-'}
                            </div>

                            <div className="mb-2">
                                <b>Transaction ID:</b>{' '}
                                {orderData.payment_txn_id||
                                    paymentResponse.txn_id||
                                    paymentResponse.id||
                                    '-'}
                            </div>

                            {orderData.payment_rrn&&(
                                <div className="mb-2">
                                    <b>RRN:</b> {orderData.payment_rrn}
                                </div>
                            )}

                            <div className="mb-2">
                                <b>Amount:</b>{' '}
                                <i className="fa fa-inr"/>
                                {' '}{Number(orderData.order_amount||0).toFixed(2)}
                            </div>

                            {paymentSuccess&&orderData.invoice_no&&(
                                <>
                                    <hr/>
                                    <div className="text-center">
                                        <a
                                            href={invoiceUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-success"
                                        >
                                            View / Download Receipt
                                        </a>
                                    </div>
                                </>
                            )}

                            <hr/>

                            <h5>Billing Address</h5>
                            <div>{orderData.bill_fname} {orderData.bill_lname}</div>
                            {orderData.bill_company&&<div>{orderData.bill_company}</div>}
                            <div>
                                {orderData.bill_adderss_one} {orderData.bill_adderss_two||''}
                            </div>
                            <div>
                                {orderData.bill_city}, {orderData.bill_state}
                            </div>
                            <div>
                                {orderData.bill_country}, {orderData.bill_pincode}
                            </div>
                            <div>{orderData.bill_mobile}</div>

                            <hr/>

                            <h5>Shipping Address</h5>
                            <div>{orderData.ship_fname} {orderData.ship_lname}</div>
                            {orderData.ship_company&&<div>{orderData.ship_company}</div>}
                            <div>
                                {orderData.ship_adderss_one} {orderData.ship_adderss_two||''}
                            </div>
                            <div>
                                {orderData.ship_city}, {orderData.ship_state}
                            </div>
                            <div>
                                {orderData.ship_country}, {orderData.ship_pincode}
                            </div>
                            <div>{orderData.ship_mobile}</div>

                        </div>
                    </Col>

                    <Col sm={7}>
                        <div className="bg-light p-lg-4 p-3 table-responsive">

                            <h5>Ordered Items</h5>

                            <table className="table">
                                <thead>
                                    <tr>
                                        <th style={{width:'10%'}}>Product</th>
                                        <th style={{width:'40%'}}></th>
                                        <th>Qty</th>
                                        <th>Price</th>
                                        <th className="text-end pe-4">Total</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {orderData.order_items?.map((item,index)=>(
                                        <tr key={index}>
                                            <td>
                                                <img
                                                    src={item.product_thumbnail}
                                                    alt=""
                                                    className="w-100"
                                                />
                                            </td>

                                            <td>
                                                <b>{item.product_name}</b>
                                                <br/>
                                                <font size="2">
                                                    SKU: {item.product_sku}
                                                </font>
                                            </td>

                                            <td>{item.product_qty}</td>

                                            <td>
                                                <i className="fa fa-inr"/>
                                                {' '}{Number(item.product_MSP||0).toFixed(2)}
                                            </td>

                                            <td className="text-end">
                                                <i className="fa fa-inr"/>
                                                {' '}
                                                {(Number(item.product_qty||0)*Number(item.product_MSP||0)).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <Row>
                                <Col sm={7}></Col>

                                <Col sm={5}>
                                    <table className="table table-borderless">
                                        <tbody>
                                            <tr>
                                                <td>Sub Total</td>
                                                <td className="text-end">
                                                    <i className="fa fa-inr"/>
                                                    {' '}
                                                    {(
                                                        Number(orderData.order_amount||0)-
                                                        Number(orderData.delivery_charges||0)
                                                    ).toFixed(2)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Discount</td>
                                                <td className="text-end">
                                                    <i className="fa fa-inr"/>
                                                    {' '}
                                                    {Number(orderData.order_discount||0).toFixed(2)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Tax</td>
                                                <td className="text-end">
                                                    <i className="fa fa-inr"/>
                                                    {' '}
                                                    {Number(orderData.order_tax||0).toFixed(2)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Delivery</td>
                                                <td className="text-end">
                                                    <i className="fa fa-inr"/>
                                                    {' '}
                                                    {Number(orderData.delivery_charges||0).toFixed(2)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td><b>Order Total</b></td>
                                                <td className="text-end main-color">
                                                    <i className="fa fa-inr"/>
                                                    {' '}
                                                    <b>
                                                        {Number(orderData.order_amount||0).toFixed(2)}
                                                    </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default OrderDetails;